import React from 'react'
import Slides from './components/Slides'

const Gallery = () => {
  return (
    <div className='my-20'>
        <Slides/>
    </div>
  )
}

export default Gallery